// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1lEIw","checkboxCol":"Table_checkboxCol__KBIat","emailCol":"Table_emailCol__3oIdj","actionCol":"Table_actionCol__3eA01"};